<template>
  <el-button type="primary" @click="handleClick">
    <template #default>
      <span class="external-button">
        {{title}}
        <i class="material-symbols-rounded icon_externalLink">open_in_new</i>
      </span>
    </template>
  </el-button>
</template>
<script>
export default {
  name: 'ExternalButton',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick (e) {
      this.$emit('click', e)
    }
  }
}
</script>
<style scoped>
.external-button {
  display: flex;
  align-items: center;
}

.external-button i {
  margin-left: 10px;
  font-size: 18px;
}
</style>
